module.exports = __webpack_public_path__ + "img/header-right.ae5da7f1.jpg";